// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"6d9322ca","977":"6a7f4632"}[chunkId] + ".chunk.js";
};